import Dexie, { Table } from 'dexie';
import { LogEvent, LoggerHook } from 'vue-logger-plugin';

import { nowSubtract } from '@/utils/dateManipulation';

export type LogEntry = {
  id?: number;
  timestamp: number;
  level: string;
  message: string;
  data: Record<string, any>;
};

export class LogEntryDb extends Dexie {
  // 'logEntries' is added by dexie when declaring the stores()
  // We just tell the typing system this is the case
  logEntries!: Table<LogEntry>;

  constructor() {
    super('logEntryDb');
    this.version(1).stores({
      logEntries: '++id, timestamp, level', // Primary key and indexed props
    });
  }
}

const loggerDb = new LogEntryDb();

export const getLoggerDb = (): LogEntryDb => {
  return loggerDb;
};

export const setupLoggerDb = async (): Promise<void> => {
  deleteOldRecords();
};

export const deleteOldRecords = (keepDays = 3) => {
  const db = getLoggerDb();
  if (!db) {
    return;
  }

  // Entries hold their timestamp as epoch millis. IndexedDB orders every
  // number before every date, so a Date bound here would match the whole
  // table rather than the entries past the retention window.
  const daysAgo = nowSubtract({ days: keepDays }).getTime();

  db.logEntries
    .where('timestamp')
    .below(daysAgo)
    .delete()
    .catch((err) => console.error(err));
};

export const DbLoggerHook: LoggerHook = {
  run(event: LogEvent) {
    const db = getLoggerDb();
    if (!db) {
      return;
    }

    db.logEntries
      .add({
        timestamp: Date.now(),
        level: event.level,
        message: event.argumentArray[0],
        data: event.argumentArray.slice(1),
      })
      .catch((err) => console.error(err));
  },
};

export const getLoggerDbStatus = (): boolean => {
  return loggerDb ? true : false;
};
